<template>
  <div>
    <Header></Header>
    <section>
      <div class="page_map">
        <ol class="breadcrumb">
          <li><router-link to="/">Home</router-link></li>
        </ol>
      </div>
      <div class="index_table">
        <table>
          <thead>
            <tr>
              <th>竞争配体ID</th>
              <th>Probe Description<br>探针描述</th>
              <th>化合物结构</th>
              <th style="min-width: 130px;">化合物俗名药物名</th>
              <th>Target Proteins ID<br>靶点ID</th>
              <th style="min-width: 130px;">Protein Description<br>蛋白描述</th>
              <th>Gene Name<br>基因名称</th>
              <th>浓度</th>
              <th width="180">竞争比值(P/PC)</th>
              <th width="180">数据来源</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for=" (v, key) in list " :for="key" :style="setstyle(v)">
              <td>
                <div>{{ v.LigandId }}</div>
              </td>
              <td></td>
              <td><img v-if="val" v-for=" (val, key1) in v.ProbeStructImg " :src="val.url" /></td>
              <td>
                <div v-html="setlistValue(v.DrugInfo)" @click="showall($event)" style=""></div>
              </td>
              <td>{{ v.ProteinId }}</td>
              <td>
                <div v-html="setlistValue(v.ProteinDescription)" @click="showall($event)" style=""></div>

              </td>
              <td>{{ v.GeneNames }}</td>
              <td>
                <div>{{ v.concentration }}</div>
              </td>
              <td>
                <div>{{ v.Ligandratio }}</div>
              </td>
              <td>

                <a href="javascript:void(0)" @click="sourcesOpen(val)" v-for="(val) in  v.Source">{{ val }}</a>
                <br>

              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagediv">
          <ul class="pagination">
            <li :class="page.pageNum <= 1 ? 'disabled' : ''" class="page-item" @click="prePage()"><a href="#">&laquo;</a>
            </li>
            <li :class="page.pageNum === index ? 'page-link active' : ''" v-for="index in pageTotal"
              @click="curPage(index)"
              v-show="(index == 1 || pageTotal == index || (index >= page.pageNum && index <= page.pageNum + 4))">
              <a href="#" v-if="(index == page.pageNum && index != 1)"
                style=" color: #337ab7;background-color: #fff;border: 1px solid #ddd;"
                @click.stop="curPage(page.pageNum - 1)">...</a>
              <a href="#">{{ index }}</a>
              <a href="#" v-if="index == (page.pageNum + 4) && pageTotal != index"
                @click.stop="curPage(page.pageNum + 1)">...</a>
            </li>
            <li :class="page.pageNum >= pageTotal ? 'disabled' : ''" class="page-item" @click="nextPage()"><a
                href="#">&raquo;</a></li>
            <li>
              <span>前往</span><input type="text" class="page_input" v-model="inputpage" @change="setpage()"><span>页</span>
            </li>
          </ul>
        </div>
      </div>

    </section>

    <div class="pop_bg" v-show="popBgShow == true"></div>
    <div class="pop_data_sources" v-show="popSourcesShow == true">
      <div class="header_info">
        <div class="title">数据来源{{ syData.datacode }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        实验编号： {{ syData.experimentnumber }}<br>
        实验日期：{{ syData.implementationdate ? syData.implementationdate : "" }}<br>
        实验设计（模板）：<div v-html="syData.designexperiments"></div>
      </div>
    </div>


    <Footer></Footer>
  </div>
</template>

<script>
import Header from './header/Index.vue'
import Footer from './footer/Index.vue'
import api from './../axios/api.js'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      popBgShow: false,
      popSourcesShow: false,
      list: [],
      syData: {},
      isarticle: false,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      total: 0, // 当前条数
      inputpage: "",
    }
  },
  mounted() {
    //console.log(111);
    this.getdetailData()
  },
  methods: {
    showall(e) {
      var morestyle = e.currentTarget.getElementsByClassName("more_text");
      if (morestyle.length > 0 && (morestyle[0].style.cssText == "display: none;")) {
        var getlite = e.currentTarget.firstElementChild.dataset.lite;
        $(e.currentTarget.firstElementChild).html(getlite);
        morestyle[0].style = "display:block;";
      } else {
        if (morestyle.length > 0 && (morestyle[0].style.cssText == "display: block;" || !morestyle[0].style.length)) {
          var gettext = e.currentTarget.firstElementChild.dataset.content;
          $(e.currentTarget.firstElementChild).html(gettext);
          morestyle[0].style = "display:none";
        }
      }
    },
    setlistValue(val) {
      var ithtml = val;
      if (val && val.length > 200) {
        var lite = val;
        if (lite.length > 200) {
          lite = lite.substring(0, 200);
        }
        ithtml = "<div data-content='" + val + "' data-lite='" + lite + "'>" + lite + "</div>";
        ithtml += '<span class="more_text">[...]</span>';
      }
      return ithtml;
    },
    setstyle(val) {
      if (val.vindex % 2 == 0) {
        return "background: #fff;";
      }
      return "background: #f4f7fb;";
    },
    setpage() {
      if (this.inputpage) {
        this.page.pageNum = parseInt(this.inputpage);
        this.getPatients(this.page.pageNum);
        this.inputpage = "";
      }
    },
    curPage(index) {
      this.getPatients(index);
    },
    prePage() {
      if (this.page.pageNum > 1) {
        this.getPatients(--this.page.pageNum);
      }
    },
    nextPage() {
      if (this.page.pageNum < this.pageTotal) {
        this.getPatients(++this.page.pageNum);
      }
    },
    getPatients(pageNum) {
      this.page.pageNum = pageNum;
      this.getdetailData();
    },
    resetVal(val) {
      let newval = "";
      if (val == undefined) {
        return "";
      }
      val.forEach(function (item) {
        newval += item + "<br>";
      })
      return newval;
    },
    sourcesOpen(val) {
      this.getdsjyData(val);
      if (!this.isarticle) {
        this.popBgShow = true;
        this.popSourcesShow = true;
      }
    },
    sourcesClose() {
      this.popBgShow = false;
      this.popSourcesShow = false;
    },
    async getdsjyData(val) {
      //查询数据源
      var that = this;
      var postdata = {
        "datacode": val
      };
      let urllist = '/action/egxqivukrqpdlzsjz/getdata';
      that.isarticle = false;
      if (val.indexOf('LDRA') != -1) {
        urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        that.isarticle = true;
      }
      await api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data) {
          that.syData = res.data.rows[0];
          if (that.isarticle) {
            window.open(that.syData.essayurl);
          }
        }
      });

    },
    async getdetailData() {
      //查询详情
      var that = this;
      var LigandId = this.$route.query.LigandId;
      var postdata = {
        LigandId: LigandId
      };
      postdata.page = that.page;
      postdata.total = that.total;
      postdata.totalPages = that.pageTotal;
      let urllist = '/action/eburqcjqvjtgtgwcx/probealldata';
      that.list = [];
      await api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data) {
          if (that.page.pageNum == 1) {
            that.pageTotal = res.data.param.totalPages;
            that.total = res.data.param.total;
          }
          let newlist = res.data.rows;
          newlist.forEach(function (val, indexl) {
            let onelist = JSON.parse(JSON.stringify(val));
            let newonelist = {};
            onelist.ProbeId.forEach(function (vv, index) {
              if (onelist.LigandId[vv] == LigandId) {
                newonelist['LigandId'] = LigandId;
                newonelist['ProbeStructImg'] = [onelist.ProbeStructImg[index]];
                newonelist['DrugInfo'] = onelist.DrugInfo;
                newonelist['ProteinId'] = onelist.ProteinId;
                newonelist['ProteinDescription'] = onelist.ProteinDescription;
                newonelist['GeneNames'] = onelist.GeneNames;
                newonelist['ProbeId'] = vv;
                let concentrationstr = onelist.concentration[vv];
                if (concentrationstr) {
                  concentrationstr = concentrationstr.join(',');
                }
                newonelist['concentration'] = concentrationstr;

                let sour = onelist.Source[vv];
                if (sour) {
                  sour = sour.join(',');
                }
                newonelist['Source'] = onelist.Source[vv];
                let Ligandratiostr = onelist.CompetitiveRatio[vv];
                if (Ligandratiostr) {
                  Ligandratiostr = Ligandratiostr.join(',');
                }
                newonelist['Ligandratio'] = Ligandratiostr;
                newonelist['vindex'] = indexl;
                that.list.push(newonelist);
              }
            })

          });
          console.log(that.list);
        }
      });

    }
  }
}
</script>
<style scoped>
.page_input {
  position: relative;
  float: left;
  padding: 5px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Competition.vue